import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "../components/SEO";
import { insights } from "../data/insights";

export default function Insights() {
  return (
    <>
      <SEO
        title="Insights & Legal Analysis"
        description="Legal insights, analysis and practitioner notes from the K & K Associates team — covering recent judgments, regulatory updates, M&A, RERA, arbitration and more."
        canonical="https://kandkassociates.com/insights"
        keywords={["legal insights India", "law firm blog", "K and K Associates insights"]}
        schema={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "Home", item: "https://kandkassociates.com/" },
            { "@type": "ListItem", position: 2, name: "Insights" },
          ],
        }}
      />

      <section className="pt-28 md:pt-40 pb-12 md:pb-16 bg-paper border-b border-rule">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <p className="kicker mb-6">Insights</p>
          <h1 className="font-display text-4xl sm:text-5xl md:text-6xl xl:text-7xl leading-[1] sm:leading-[0.98] text-ink">
            Notes from the <span className="italic text-brand">desk.</span>
          </h1>
          <p className="mt-8 font-serif text-xl text-ink/70 max-w-3xl leading-relaxed">
            Practitioner-grade analysis on the developments shaping Indian law — written for general counsel, founders and informed clients.
          </p>
        </div>
      </section>

      <section className="py-16 bg-bone">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 border-t border-l border-rule">
            {insights.map((post, i) => (
              <Link
                key={post.slug}
                to={`/insights/${post.slug}`}
                data-testid={`insight-card-${post.slug}`}
                className="group border-r border-b border-rule p-10 md:p-12 bg-paper hover:bg-bone transition-colors duration-500 flex flex-col justify-between min-h-[320px]"
              >
                <div>
                  <div className="flex items-center gap-4 mb-6">
                    <p className="kicker">{post.category}</p>
                    <span className="text-xs tracking-widest text-ink/50">·</span>
                    <p className="text-xs tracking-widest text-ink/50">{post.readTime}</p>
                  </div>
                  <h2 className="font-display text-2xl md:text-3xl text-ink leading-tight group-hover:text-brand transition-colors">
                    {post.title}
                  </h2>
                  <p className="mt-5 font-serif text-lg text-ink/70 leading-snug">{post.excerpt}</p>
                </div>
                <div className="mt-8 flex items-center justify-between">
                  <p className="text-xs tracking-widest text-ink/50">{new Date(post.date).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}</p>
                  <ArrowRight className="w-5 h-5 text-ink/40 group-hover:text-brand group-hover:translate-x-1 transition-all" strokeWidth={1.25} />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
